export const CUSTOMER_CLIENT_CHARTER =
  "https://www.alrajhibank.com.my/assets/pdf/client-charter/customer_service_charter.pdf";
